module.exports = __webpack_public_path__ + "img/SYM09.b1871c61.gif";